import { Component, OnInit, ViewChild } from '@angular/core';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { RowAction } from 'src/app/shared/base-reporting/models/row-actions.interface';
import { FilterItem } from 'src/app/shared/base-reporting/models/filter-item.interface';
import * as moment from 'moment';
import { FilterCallback } from 'src/app/shared/base-reporting/models/filter-callback.interface';
import { RowActionCallback } from 'src/app/shared/base-reporting/models/row-action-callback.interface';
import { FaqGroup } from 'src/app/shared/models/faq-group.model';
import { FaqsService } from '../faqs.service';

@Component({
  selector: 'app-faqs-group',
  templateUrl: './faqs-group.component.html',
  styleUrls: ['./faqs-group.component.css']
})
export class FaqsGroupComponent implements OnInit {
  groupForm: DVFormGroup;
  isAddState = true;
  addFaqGroup = false;
  faq = new FaqGroup();
  tableColumns = ['name', 'createdAt', 'updatedAt'];
  rowActions: Array<RowAction> = [
    {
      type: 'icon',
      slug: 'editFaqGroup',
      class: 'btn',
      iconClasses: 'fa fa-edit'
    },
    {
      type: 'icon',
      slug: 'deleteFaqGroup',
      class: 'btn',
      iconClasses: 'fa fa-trash'
    }
  ];
  reportFilter: Array<FilterItem> = [
    {
      fieldName: 'name',
      fieldDisplayName: 'FAQ Group Name ',
      fieldType: 'text'
    },
    {
      fieldName: 'createdAt',
      fieldDisplayName: 'created At ',
      fieldType: 'daterange'
    }
  ];
  private Data = [] as Array<TableViewItem>;
  currentFilterObject = {} as FilterModel;
  constructor(
    private faqsApi: FaqsService,
    private notifier: SnotifyService
  ) {
    this.groupForm = new DVFormGroup({
      name: new DVFormControl(null, {
        'Group Name  is required': Validators.required
      })
    });
  }
  ngOnInit() {
    this.fetchAllFaqs();
  }
  addGroup() {
    if (this.groupForm.valid) {
      this.faqsApi.addGroupFaq(this.groupForm.value).subscribe(
        Response => {
          // console.log(Response);
          this.notifier.success('Group FAQ is Added Successfully');
          this.groupForm.reset();
          this.addFaqGroup = true;
          this.fetchAllFaqs();
        },
        err => {
          this.notifier.error(err.err.userMessage);
        }
      );
    } else {
      this.groupForm.forceShowErrors();
    }
  }
  editGroup() {
    this.faqsApi
      .editGroupFaq(this.groupForm.value, this.faq.id)
      .subscribe(Response => {
        // console.log(Response);
        this.notifier.success(
          'Group ' + this.faq.name + ' Has Edited SuccessFully '
        );

        this.isAddState = true;
        this.groupForm.reset();
        this.fetchAllFaqs();
      });
  }
  deleteGroup(row) {
    this.faqsApi.deleteGroupFaq(row.id).subscribe(Response => {
      // console.log(Response);
      this.notifier.success('Group ' + row.name + ' Has Deleted SuccessFully ');
      this.fetchAllFaqs();
    });
  }
  cancel() {
    this.isAddState = true;
    this.groupForm.reset();
  }
  returnedTableReference(event) {
    // console.log(event)
  }
  get data(): Array<TableViewItem> {
    return this.Data.filter(row => {
      if (
        this.currentFilterObject.createdAt &&
        this.currentFilterObject.createdAt.startDate &&
        this.currentFilterObject.createdAt.endDate
      ) {
        return moment(row.createdAt).isBetween(
          // @ts-ignore
          this.currentFilterObject.expiresAt.startDate._i,
          // @ts-ignore
          this.currentFilterObject.expiresAt.endDate._i
        );
      } else {
        return true;
      }
    }).filter(row => {
      if (this.currentFilterObject.name) {
        return row.name.includes(this.currentFilterObject.name);
      }
      return true;
    });
  }
  set data(v: Array<TableViewItem>) {
    this.Data = v;
  }

  onFilter(event: FilterCallback) {
    this.currentFilterObject = event.filter;
  }

  private fetchAllFaqs() {
    this.faqsApi.getGroupFaq().subscribe(response => {
      this.data = response.data.faqGroups.map(r => {
        return {
          id: r.id,
          name: r.name,
          createdAt: r.createdAt,
          updatedAt: r.updatedAt
        } as TableViewItem;
      });
    });
  }
  rowActionCB(event: RowActionCallback) {
    switch (event.action) {
      case 'editFaqGroup':
        this.faq = event.on;
        this.isAddState = false;
        this.groupForm.controls[`name`].setValue(this.faq.name);
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });
        break;
      case 'deleteFaqGroup':
        this.faq = event.on;
        this.deleteGroup(this.faq);
        break;
      default:
        console.error('this is a mistake!');
    }
  }
  fetchTable(event) {
    if (event[`flag`] === true) {
      this.fetchAllFaqs();
    }
  }
}

interface TableViewItem {
  id?: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
}

interface FilterModel {
  name?: string;
  createdAt?: DateRangeModel;
}

interface DateRangeModel {
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}
